export default "__VITE_ASSET__bd3cabb9__"